import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { prettyFloatMoney } from '@/helpers/utils';
import { APP_LINKS } from '@/helpers/links';
import { EMPTY_DASH } from '@/helpers/constants';
import { MyLink } from '@/components/MyLink';
import { useGetRiskFactorStatus } from '@/query/queries/fundraising/useGetRiskFactorStatus';
import Icon from './icon_info.svg';
import s from './index.module.scss';

export const RiskFactorStatus = () => {
  const { data } = useGetRiskFactorStatus();
  const { t } = useTranslation('dashboard');
  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className={s.group}>
          <div className={classnames(s.label, 'f-label')} style={{ paddingRight: '30px' }}>
            {t('risk_factory_status.your_risk_score')}
          </div>
          <div className={classnames(s.value, 'f-body')} style={{ textTransform: 'capitalize' }}>
            {data ? data.risk_factor : EMPTY_DASH}
          </div>
        </div>
        <MyLink className={s.link} isExternal newWindow href={APP_LINKS.loanTermsPlans()}>
          <img src={Icon} width={24} height={24} alt="icon" />
        </MyLink>
        <div className={s.bottom}>
          <div className={s.group}>
            <div className={classnames(s.label, 'f-label')}>
              {t('risk_factory_status.available_credit_limit')}
            </div>
            <div className={classnames(s.value, 'f-body')}>
              {data ? prettyFloatMoney(data.available_credit_limit) : EMPTY_DASH}
            </div>
          </div>
          <div className={s.group}>
            <div className={classnames(s.label, 'f-label')}>
              {t('risk_factory_status.limit_for_the_round')}
            </div>
            <div className={classnames(s.value, 'f-body')}>
              {data?.limit_for_round
                ? prettyFloatMoney(data.limit_for_round)
                : t('risk_factory_status.not_set_yet')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
